"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCancelMeasurePageLoad = exports.useTrackPageLoad = void 0;
var react_1 = require("react");
var PageLoadProvider_1 = require("./PageLoadProvider");
/**
 * This hooks records a page view when loading === false, if there is an error
 * the result of the load is tracked as an error. Only one load is ever tracked,
 * even if loading flips between true and false several times.
 * This hook relies on `PageLoadMetricsProvider` and tracks page views. Metrics
 * are reported up with the duration and result of each page load.
 * @param {*} loading Boolean indicating when the page is loading.
 * @param {*} error An error obect for the page.
 * @param {*} disabled Boolean indicating if a page wants metrics disabled
 * @param {*} data Custom data a page can send to track a page load
 */
var useTrackPageLoad = function (loading, error, disabled, data) {
    var _a = (0, PageLoadProvider_1.usePageLoadApi)(), url = _a.url, trackPageLoad = _a.trackPageLoad, initMetrics = _a.initMetrics;
    var loadedRef = (0, react_1.useRef)(false);
    /**
     * Init metrics once page is mounted to guaranteed we always have
     * a metrics client initialized.
     */
    (0, react_1.useEffect)(function () {
        // If the page is overriding the metrics behaviour we short circuit
        if (disabled)
            return;
        initMetrics(url);
    }, [initMetrics, disabled, url]);
    (0, react_1.useEffect)(function () {
        // If the page is overriding the metrics behaviour we short circuit
        if (disabled)
            return;
        if (loading === false && !loadedRef.current) {
            if (error) {
                trackPageLoad(url, 'error', __assign(__assign({}, data), { type: 'handled_error', error_message: error.message }));
            }
            else {
                trackPageLoad(url, 'success', __assign(__assign({}, data), { type: 'tracked' }));
            }
            loadedRef.current = true;
        }
    }, [error, loading, trackPageLoad, url, disabled, data]);
};
exports.useTrackPageLoad = useTrackPageLoad;
var useCancelMeasurePageLoad = function () {
    var cancelMeasurePageLoad = (0, PageLoadProvider_1.usePageLoadApi)().cancelMeasurePageLoad;
    return cancelMeasurePageLoad;
};
exports.useCancelMeasurePageLoad = useCancelMeasurePageLoad;
